import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages_ca from './lang/ca.js'
import messages_es from './lang/es.js'
import '../bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'iframe-resizer/js/iframeResizer.contentWindow.min';
import router from './router';
import tooltipDirective from './directives/tooltipDirective';
// import '../../vendor/cookiecuttr/cookiecuttr.js'


Vue.directive('tooltip', tooltipDirective);
Vue.use(VueI18n);

const messages = {
    'es': messages_es,
    'ca': messages_ca,
};

const htmlLocale = document.getElementsByTagName('html')[0].getAttribute('lang');

const i18n = new VueI18n({
    locale: htmlLocale,
    messages,
});

new Vue({
    el: "#app",
    i18n,
    router,
    data: function () {
        return {}
    },
});

